module.exports = __webpack_public_path__ + "img/icon-sound-on.0a2ef499.svg";